export default __webpack_public_path__ + "static/media/incorrect-circle.421c5367.svg";